import { create } from 'zustand';
import { CoastCalculationStore } from '../type/CoastCalculationStore';

export const useCoastCalculationStore = create<CoastCalculationStore>((set) => ({
    isPartner: false,
    bankIsDisabled: false,
    isSber: false,

    setIsPartner: (isPartner) => {
        set(() => ({
            isPartner,
        }));
    },
    setBankIsDisabled: (bankIsDisabled) => {
        set(() => ({
            bankIsDisabled,
        }));
    },
    setIsSber: (isSber) =>
        set(() => ({
            isSber,
        })),
    cleanUpCoastCalculationStore: () =>
        set(() => ({
            isPartner: false,
            bankIsDisabled: false,
            isSber: false,
        })),
}));
